'use client'

import Link from 'next/link'
import { ArrowRight } from 'lucide-react'
import type { ExamSearchEntry } from '@/data/exams/search-index'

interface MobileSearchResultsProps {
  results: ExamSearchEntry[]
  query: string
}

export function MobileSearchResults({
  results,
  query,
}: MobileSearchResultsProps) {
  if (results.length === 0) {
    return (
      <div className="px-2 py-10 text-center">
        <p className="text-body text-sm">
          No exams match &ldquo;{query}&rdquo;
        </p>
        <Link
          href="/exams"
          className="text-primary hover:text-primary-hover mt-2 inline-flex min-h-11 items-center gap-1.5 text-sm font-semibold transition-colors"
        >
          Browse all exams
          <ArrowRight size={15} />
        </Link>
      </div>
    )
  }

  return (
    <ul aria-label="Search results">
      {results.map((entry) => (
        <li key={entry.slug}>
          <Link
            href={`/exam/${entry.slug}`}
            className="hover:bg-surface flex min-h-11 flex-col justify-center rounded-xl px-2 py-1.5 transition-colors"
          >
            <span className="font-heading text-ink text-[15px] font-semibold slashed-zero">
              {entry.name}
            </span>
            <span className="text-hint truncate text-[13px]">
              {entry.full} · {entry.industry}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  )
}
